<template>
  <div v-loading="loading">
    <div class="title">创建挑战</div>
    <el-card shadow="hover">
      <div slot="header"><span class="brand-color">基础信息</span></div>
      <el-form
        :model="infoForm"
        ref="infoForm"
        label-width="95px"
        size="mini"
        :rules="rules"
      >
        <el-form-item label="挑战名称：" class="wd-40" prop="name">
          <el-input
            v-model="infoForm.name"
            placeholder="请输入名称"
            class="wd-270"
          ></el-input>
        </el-form-item>
        <el-form-item label="挑战难度：" class="wd-40" prop="difficult_level">
          <el-select
            v-model="infoForm.difficult_level"
            placeholder="请选择难度"
            class="wd-270"
          >
            <el-option
              v-for="(item, index) in difficult_level_list"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用场景：" required>
          <el-select
            multiple
            v-model="infoForm.use_cases"
            placeholder="请选择应用场景"
            class="wd-270"
          >
            <el-option label="实战营" :value="1"></el-option>
            <el-option label="赛训" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业分类：">
          <el-cascader
            v-model="infoForm.common_industries"
            :options="industryList"
            :props="optionProps"
            class="wd-270"
            placeholder="请选择行业分类"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="岗位方向：" required>
          <CascaderPosition
            size="mini"
            multiple
            placeholder="请选择岗位方向"
            :jobId.sync="infoForm.job_id"
            :emitPath="false"
            @getNodes="handleGetJob"
          ></CascaderPosition>
        </el-form-item>
        <el-form-item label="技能认证：" required>
          <ProjectStackSelect :stacks="infoForm.stacks"></ProjectStackSelect>
        </el-form-item>
        <!-- <el-form-item label="挑战封面：" class="wd-40 upload">
          <div class="upload-tips">建议尺寸：590*340，jpg/png，不超过5M</div>
          <upload-image
            :api="api"
            space="_for_challenge_sub_project"
            folder="fuwu"
            uploadWidth="upload-w-270"
            :cover_url.sync="(infoForm.cover_file || {}).path"
            :cover_file_id.sync="(infoForm.cover_file || {}).id"
          ></upload-image>
        </el-form-item>
        <el-form-item label="成功勋章：" class="wd-40 upload">
          <div class="upload-tips">建议尺寸：288*288，jpg/png，不超过5M</div>
          <upload-image
            :api="api"
            space="_for_challenge_sub_project"
            folder="fuwu"
            uploadWidth="upload-w-270"
            :cover_url.sync="(infoForm.medal_file || {}).path"
            :cover_file_id.sync="(infoForm.medal_file || {}).id"
          ></upload-image>
        </el-form-item> -->
        <el-form-item label="挑战简介：" prop="description">
          <el-input
            v-model="infoForm.description"
            type="textarea"
            :rows="5"
            class="w-680"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-tooltip
          class="item"
          effect="dark"
          content="填写基本信息后，将创建挑战填写更多信息 ～"
          placement="top"
        >
          <zhu-button
            @click="handleSubmit"
            type="primary"
            :shadow="true"
            text="确认"
            v-if="
              authPermissions.includes(
                'challenge_service.api.fuwu_admin.my_challenges.store'
              )
            "
          ></zhu-button>
        </el-tooltip>
      </div>
    </el-card>
  </div>
</template>
<script>
import ProjectStackSelect from "@/components/ProjectStackSelect.vue";
import API from "@/global/request/api";
import kcellService from "@/global/service/kcell";
import challengeService from "@/global/service/challenge";
import CascaderPosition from "./widgets/CascaderPosition.vue";
import { mapState } from "vuex";

const difficult_level_list = [
  {
    label: "R1-简单",
    value: 1
  },
  {
    label: "R2-一般",
    value: 2
  },
  {
    label: "R3-中等",
    value: 3
  },
  {
    label: "R4-困难",
    value: 4
  },
  {
    label: "R5-非常困难",
    value: 5
  }
];
export default {
  components: {
    ProjectStackSelect,
    CascaderPosition
  },
  data() {
    return {
      loading: false,
      infoForm: {
        description: null,
        name: null,
        difficult_level: null,
        use_cases: [],
        common_industries: [],
        stacks: [],
        content: null,
        job_id: null
      },
      difficult_level_list,
      isAdd: false,
      api: API.challengeFile,
      rules: {
        name: [{ required: true, message: "请输入挑战名称", trigger: "blur" }],
        difficult_level: [
          { required: true, message: "请选择难度", trigger: "change" }
        ],
        use_cases: [
          { required: true, message: "请选择使用场景", trigger: "change" }
        ],
        description: [
          { required: true, message: "请输入简介", trigger: "blur" }
        ]
      },
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false,
        checkStrictly: false,
        multiple: true
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getConst();
  },
  methods: {
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    handleSubmit() {
      this.$refs.infoForm.validate(valid => {
        if (!valid) {
          this.$message.error("缺少必要参数");
          return;
        }
        this.loading = true;
        const params = {
          challenge_task_id: this.$route.params.id,
          name: this.infoForm.name,
          description: this.infoForm.description,
          difficult_level: this.infoForm.difficult_level,
          use_cases: this.infoForm.use_cases,
          common_industries: this.infoForm.common_industries,
          jobs: this.infoForm.job_id.map(s => {
            return {
              job_id: s
            };
          }),
          stacks: this.infoForm.stacks.map(data => {
            data = {
              stack_id: data.id,
              stack_level: data.level
            };
            return data;
          })
        };
        const hasStacks = params.stacks.length;
        if (!hasStacks) return this.$message.error("技能认证不能为空 ～");
        challengeService
          .createMyChallenge(params)
          .then(res => {
            this.$message.success("创建成功");
            setTimeout(() => {
              this.$router.push({
                name: "ChallengeDetail",
                params: { id: res.id }
              });
            }, 1000);
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    handleGetJob(e) {
      this.infoForm.job_id = e.map(s => s.value);
    }
  }
};
</script>
<style lang="less" scoped>
.el-card {
  margin-bottom: 20px;
}

.upload {
  margin-right: 70px;
  /deep/.el-form-item__content {
    line-height: 60px;
  }
  /deep/.upload-icon {
    width: 270px;
    height: 130px;
    line-height: 120px;
    font-size: 20px;
  }
}

.add-btn {
  padding: 0;
}
.wd-270 {
  width: 270px;
  margin-right: 70px;
}
.btn-box {
  margin-top: 30px;
  display: flex;
  padding-left: 95px;
  padding-bottom: 30px;
  .el-button {
    width: 220px;
  }
}
.cancel-btn {
  margin-left: 85px;
}
.content-btn {
  margin: 30px auto 0;
  display: block;
}
.upload-tips {
  line-height: 28px;
  margin-bottom: 10px;
}
</style>
